import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { catchError, map, of } from 'rxjs';

export const notAuthenticatedGuard: CanActivateFn = (route, state) => {
    let authenticationService = inject(AuthenticationService);
    let router = inject(Router);
    return authenticationService.ping().pipe(
        map(pingResult => {
            if (!pingResult) {
                return !pingResult;
            } else {
                return getProjectsPageUrlTree(router);
            }
        }),
        catchError(() => of(true))
    );
};

const getProjectsPageUrlTree: (router: Router) => UrlTree = (router: Router) => router.createUrlTree(['projects']);
